import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IReReframeVerticalsRequest } from './re-reframe-verticals-request';
import type { IReReframeVerticalsResponse } from './re-reframe-verticals-response';
import { reReframeVerticalsResponseSchema } from './re-reframe-verticals-response';

export async function reReframeVerticalsApi(
  body?: IReReframeVerticalsRequest,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IReReframeVerticalsResponse>> {
  return postRequest<IReReframeVerticalsResponse>({
    path: '/sys/pipeline/re-reframe-verticals/v1',
    body: body ?? {},
    schema: reReframeVerticalsResponseSchema,
    options,
  });
}
